<app-uni-page [parent]="this" pageTitle="Accounts" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"> </app-uni-page>
<ng-template #bodyTemplate>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[40, 60]">
    <ng-template pTemplate>
      <div class="flex h-full w-full flex-col overflow-hidden">
        <div class="grow pb-2">
          <app-ag-grid [gridOptions]="accGridOptions" class="h-full"></app-ag-grid>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex h-full w-full flex-row overflow-hidden">
        <div class="mr-4 flex h-full flex-col pb-2">
          <h5 class="m-0 py-2">&nbsp;</h5>
          <div class="qb-grid-action-panel">
            <button
              pButton
              type="button"
              class="p-button-raised p-button-sm w-full"
              icon="pi pi-file-excel"
              [disabled]="!selectedAccount"
              (click)="exportInvoicesToExcel()"
            >
              <span>Export to Excel</span>
            </button>
            <button
              pButton
              type="button"
              class="p-button-raised p-button-sm w-full"
              icon="pi pi-file-excel"
              [disabled]="!selectedAccount"
              (click)="createRestockInvoice()"
            >
              <span>Invoice Restock Fees</span>
            </button>
          </div>
        </div>
        <div class="flex h-full flex-1 flex-col pb-2">
          <h5 class="m-0 py-2">{{ selectedAccount?.accountName }}</h5>
          <div class="h-full w-3/4">
            <p-tabView class="uni-tabview h-full w-full" styleclass="h-full">
              <p-tabPanel header="Invoices">
                <app-ag-grid [gridOptions]="invhGridOptions" class="h-full"></app-ag-grid>
              </p-tabPanel>
              <p-tabPanel header="Credit Memos and Refunds">
                <app-ag-grid [gridOptions]="cmGridOptions" class="h-full"></app-ag-grid>
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
